import {
    useMemo, useEffect, useState, useCallback
} from 'react';
import { withRouter } from 'react-router-dom';
import { messages as commonMessages } from 'gw-platform-translations';
import { error } from '@jutro/logger';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { ModalNextProvider } from '@jutro/components';

import { PersonalizedOfferService } from 'gw-capability-personalizedoffers';
import { useAuthentication } from 'gw-digital-auth-react';

import PersonalizedOfferUtil from '../../util/PersonalizedOffersUtil';
import metadata from './PersonalizedOfferComponent.metadata.json5';
import styles from './PersonalizedOfferComponent.module.scss';

function PersonalizedOfferComponent(props) {
    const {
        match, offer, className, history, type
    } = props;
    const { capabilitiesConfig: { personalizedoffers } } = appConfig;
    const { path, params } = match;
    const { authHeader } = useAuthentication();
    const [offerData, setOfferData] = useState({});

    useEffect(() => {
        if (_.isEmpty(offer)) {
            PersonalizedOfferService.getOfferDataFromServer(path, params, authHeader)
                .then((offers) => PersonalizedOfferUtil.pickOffer(offers, type))
                .then(setOfferData)
                // TDIC - Do not remove: Exception and logger added for production support
                .catch((err) => {
                    error(`PersonalizedOfferComponent: getOfferDataFromServer - Unable to get offer data from server ${JSON.stringify(err)}`);
                    return ModalNextProvider.showAlert({
                        title: commonMessages.genericError,
                        message: commonMessages.genericErrorMessage,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok
                    }).then(() => {
                        history.push('/error');
                    }, _.noop);
                });
        }
        // prevent re render
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [offer, path]);

    const personalizedOfferData = useMemo(() => {
        if (_.isEmpty(offer)) {
            return offerData;
        }
        return offer;
    }, [offer, offerData]);

    const handleOfferClick = useCallback((event) => {
        event.preventDefault();
        history.push(_.get(personalizedOfferData, 'destinationUrl'));
    }, [history, personalizedOfferData]);

    const getImagePath = useCallback(() => {
        const relativeUrl = _.get(personalizedOfferData, 'content.value.url', '');
        const { urlPrefix } = personalizedOfferData;
        return urlPrefix ? PersonalizedOfferUtil.concatUrl(urlPrefix, relativeUrl) : '';
    }, [personalizedOfferData]);

    if (!personalizedoffers || _.isEmpty(personalizedOfferData)) {
        return null;
    }

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onOfferClick: handleOfferClick
        }
    };
    const overrides = {
        offerContainer: {
            className: classNames(className, {
                [styles.rectangleOfferContainer]: personalizedOfferData.offerType === 'rectangle',
                [styles.leaderBoardOfferContainer]: personalizedOfferData.offerType === 'leaderboard'
            })
        },
        text: {
            title: _.get(personalizedOfferData, 'content.value.text'),
            visible: _.get(personalizedOfferData, 'content.type') === 'text'
        },
        image: {
            visible: _.get(personalizedOfferData, 'content.type') === 'image',
            src: _.get(personalizedOfferData, 'content.type') === 'image' ? getImagePath() : ''
        }
    };

    return renderContentFromMetadata(metadata.componentContent, overrides, resolvers);
}

PersonalizedOfferComponent.propTypes = {
    type: PropTypes.string.isRequired
};
export default withRouter(PersonalizedOfferComponent);
